import { get, post } from './common'

type ApiBaseResult = ApiTypes.ApiBaseResult

export namespace word {
  // 获取前端直传签名地址
  export function getWordUploadSignUrl(
    data: {
      module: PostDataTypes.FileUploadModule
      filename: string
      // 文件大小，单位：字节
      contentLength: number
      md5?: string
      pageNum?: number
    },
    controller?: AbortController
  ): Promise<
    ApiBaseResult & {
      data: {
        signUrl: string
        fileId: number
        fileName: string
        hasUpload: boolean
        display: boolean
      }
    }
  > {
    return post('/upload/sign_url/v2', {}, { ...data }, undefined, controller)
  }

  export function updateUploadStatus(
    params: {
      fileId: number
      source: 'word_translate'
    },
    controller?: AbortController
  ) {
    return post('/upload/update_status', {}, { ...params }, undefined, controller)
  }

  // 开始翻译文件
  export function startTranslateWord(
    data: {
      fileId: number
      fromLang: string
      toLang: string
      translateModel: string
      openGlossary: boolean
      contextMode: PostDataTypes.ContextType
    },
    controller?: AbortController
  ): Promise<ApiBaseResult> {
    return post('/word/translate', {}, { ...data }, undefined, controller)
  }

  //

  /** 检测 word翻译 的状态 */
  export function checkWordTranslateStatus(
    fileId: number,
    controller: AbortController
  ): Promise<
    ApiBaseResult & {
      status: ServerDataTypes.PDF.Pdf2HtmlStatus
      downloadInfo: ServerDataTypes.WORD.WordDownloadInfo
    }
  > {
    return get('/word/translate/status', { fileId }, undefined, controller)
  }

  export function wordHistory(params: {
    keyword?: string
    limit?: number
    offset?: number
    module?: PostDataTypes.FileUploadModule
  }): Promise<
    ApiBaseResult & {
      totalCount: number
      dataList: Array<ServerDataTypes.WORD.FileInfo>
    }
  > {
    return get('/file_list/v2', { ...params })
  }

  export function deleteWordHistory(fileId: number): Promise<ApiBaseResult> {
    return get('/file/delete', { fileId })
  }
}
